module.exports = __webpack_public_path__ + "img/preview_logo.3e7d7e10.png";